// import { useCallback, useEffect, useState } from 'react';
// import Oidc from 'oidc-client';
// import axios from 'axios';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';

// import { loadConfig, IDENTITY_MANAGER_CONFIG } from 'config';
// import { RootState } from 'reducers';
// import { Status } from 'reducers/enum';
// import {
//     retrieveAllLicensesThunk,
//     retrieveIntegrationsThunk,
// } from 'reducers/integrations/actions';
// import {
//     setAccessToken,
//     setAccountId,
//     setAuthToken,
//     setUserRoles,
// } from 'reducers/credentials/actions';

// import Routing from 'components/Routing/Routing';
// import AppBar from 'components/AppBar/AppBar';
// import AppFooter from 'components/AppFooter/AppFooter';

// import './app.scss';
// import LoaderOverlay from 'components/LoaderOverlay/LoaderOverlay';

// import { getUserRoles } from 'lib/api';
// import {
//     selectCanManageLicenses,
//     selectCanManageIntegrations,
// } from 'reducers/credentials/selectors';

// loadConfig();
// const config: Oidc.UserManagerSettings = IDENTITY_MANAGER_CONFIG()
// const identityManager = new Oidc.UserManager(config);

// function App() {
//     const [isAuthenticated, setIsAuthenticated] = useState(false);
//     const [isAuthorized, setIsAuthorized] = useState(false);
//     const dispatch = useDispatch();
//     const location = useLocation();

//     const integrationIds = useSelector(
//         (state: RootState) => state.integrations.allIds
//     );
//     const retrieveIntegrationsStatus = useSelector(
//         (state: RootState) => state.integrations.retrieveIntegrationsStatus
//     );
//     const retrieveAllLicensesStatus = useSelector(
//         (state: RootState) => state.integrations.retrieveAllLicensesStatus
//     );

//     const userRoles = useSelector(
//         (state: RootState) => state.credentials.userRoles
//     );

//     const canManageLicenses = useSelector(selectCanManageLicenses);
//     const canManageIntegrations = useSelector(selectCanManageIntegrations);

//     const handleAuthenticatedChanged = useCallback(() => {
//         identityManager.getUser().then(async (user) => {
//             if (user && !user.expired) {
//                 dispatch(setAuthToken(`Bearer ${user.access_token}`));
//                 axios.defaults.headers.common = {
//                     Authorization: `Bearer ${user.access_token}`,
//                 };
//                 identityManager.startSilentRenew();
//                 setIsAuthenticated(true);
//                 dispatch(setAccountId(user.profile.company_id));
//                 /*Fetch user roles from claim*/
//                 const userRoles =await identityManager.getUser().then(async (user) => {
//                     // Extract roles from the user's claims/access token
//                     const roles = extractRolesFromClaims(user);
//                     console.log('User roles from claims:', roles);
//                     return roles;
//                 });
//                 dispatch(setUserRoles(userRoles));
//             } else {
//                 if (
//                     location.pathname == null ||
//                     !location.pathname.includes('authentication-callback')
//                 ) {
//                     identityManager
//                         .signinRedirect()
//                         .catch((error) => console.log(error));
//                 }
//             }
//         });
//     }, [dispatch]);

//     const handleLoginButtonClicked = useCallback(() => {
//         if (isAuthenticated) {
//             identityManager
//                 .signoutRedirect()
//                 .catch((error) => console.log(error));
//         } else {
//             identityManager
//                 .signinRedirect()
//                 .catch((error) => console.log(error));
//         }
//     }, [isAuthenticated]);

//     // Authenticate user
//     useEffect(() => {
//         if (!isAuthenticated) {
//             handleAuthenticatedChanged();
//         }
//     }, [handleAuthenticatedChanged, isAuthenticated]);

//     // Set authorization status
//     useEffect(() => {
//         if (
//             isAuthenticated &&
//             (canManageLicenses || canManageIntegrations) &&
//             !isAuthorized
//         ) {
//             setIsAuthorized(true);
//         }
//     }, [
//         dispatch,
//         isAuthenticated,
//         isAuthorized,
//         canManageLicenses,
//         canManageIntegrations,
//     ]);

//     // Retrieve integrations
//     useEffect(() => {
//         if (
//             isAuthenticated &&
//             isAuthorized &&
//             retrieveIntegrationsStatus === Status.Idle
//         ) {
//             dispatch(retrieveIntegrationsThunk());
//         }
//     }, [
//         dispatch,
//         isAuthenticated,
//         isAuthorized,
//         retrieveIntegrationsStatus,
//     ]);

//     // Retrieve licenses
//     useEffect(() => {
//         if (
//             isAuthenticated &&
//             isAuthorized &&
//             retrieveIntegrationsStatus === Status.Finished &&
//             retrieveAllLicensesStatus === Status.Idle
//         ) {
//             dispatch(retrieveAllLicensesThunk({ integrationIds }));
//         }
//     }, [
//         integrationIds,
//         dispatch,
//         isAuthenticated,
//         isAuthorized,
//         retrieveIntegrationsStatus,
//         retrieveAllLicensesStatus,
//     ]);

//     const isLoading =
//         userRoles !== undefined && !(canManageLicenses || canManageIntegrations)
//             ? false
//             : isAuthenticated &&
//               (retrieveIntegrationsStatus !== Status.Finished ||
//                   retrieveAllLicensesStatus !== Status.Finished);

//     return (
//         <>
//             <LoaderOverlay isLoading={isLoading} />
//             <AppBar
//                 isAuthenticated={isAuthenticated}
//                 onLoginButtonClicked={handleLoginButtonClicked}
//             />
//             <div className="container-fluid my-10">
//                 <div className="row">
//                     <div className="col-12">
//                         {!isLoading && (
//                             <Routing
//                                 isAuthenticated={isAuthenticated}
//                                 onAuthorizedEvent={handleAuthenticatedChanged}
//                                 authConfig={config}
//                             />
//                         )}
//                     </div>
//                 </div>
//             </div>            
//             <AppFooter />
//         </>
//     );
// }

// function extractRolesFromClaims(user) {
//     // Method 1: Check common claim locations for roles
//     if (user?.profile?.roles) {
//         return user.profile.roles;
//     }

//     if (user?.access_token?.claims?.roles) {
//         return user.access_token.claims.roles;
//     }

//     if (user?.id_token?.claims?.roles) {
//         return user.id_token.claims.roles;
//     }

//     // Method 2: Check for role claims in token (common patterns)
//     const token = user?.access_token;
//     if (token) {
//         const payload = parseJwt(token);
//         return payload.roles || payload.Roles || payload.role || payload.Role || [];
//     }

//     return [];
// }

// // Helper function to parse JWT token
// function parseJwt(token) {
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
//             return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//         }).join(''));
//         return JSON.parse(jsonPayload);
//     } catch (error) {
//         console.error('Failed to parse JWT:', error);
//         return {};
//     }
// }

// export default App;



// src/App.tsx
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RootState } from "reducers";
import { Status } from "reducers/enum";
import {
    retrieveAllLicensesThunk,
    retrieveIntegrationsThunk,
} from "reducers/integrations/actions";
import {
    setAuthToken,
    setAccountId,
   /* setUserRoles,*/
} from "reducers/credentials/actions";
import AppBar from "components/AppBar/AppBar";
import AppFooter from "components/AppFooter/AppFooter";
import LoaderOverlay from "components/LoaderOverlay/LoaderOverlay";
import Routing from "components/Routing/Routing";
import { parseJwt } from "lib/jwtUtils";
import {
    msalInstance,
    login,
    logout,
    acquireAccessToken,
    getAccount,
} from "authService";

import {
    selectCanManageLicenses,
    selectCanManageIntegrations,
} from "reducers/credentials/selectors";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();

    const integrationIds = useSelector((state: RootState) => state.integrations.allIds);
    const retrieveIntegrationsStatus = useSelector((state: RootState) => state.integrations.retrieveIntegrationsStatus);
    const retrieveAllLicensesStatus = useSelector((state: RootState) => state.integrations.retrieveAllLicensesStatus);

    const canManageLicenses = useSelector(selectCanManageLicenses);
    const canManageIntegrations = useSelector(selectCanManageIntegrations);


    const handleAuthenticated = useCallback(async () => {
        const token = await acquireAccessToken();
        if (token) {
            const claims = parseJwt(token);
            setIsAuthenticated(true);
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            dispatch(setAuthToken(`Bearer ${token}`));
            dispatch(setAccountId(claims.oid || claims.sub || ""));
          /*  dispatch(setUserRoles(claims.roles || []));*/
        } else {
            await login();
        }
    }, [dispatch]);

    const handleLoginButtonClicked = () => (isAuthenticated ? logout() : login());

    // Handle redirect result from login
    useEffect(() => {
        msalInstance.handleRedirectPromise().then(async (result) => {
            console.log("MSAL Redirect Result:", result);

            if (result && result.accessToken) {
                const claims = parseJwt(result.accessToken);
                setIsAuthenticated(true);
                axios.defaults.headers.common.Authorization = `Bearer ${result.accessToken}`;
                dispatch(setAuthToken(`Bearer ${result.accessToken}`));
                dispatch(setAccountId(claims.oid || claims.sub || ""));
               /* dispatch(setUserRoles(claims.roles || []));*/
            } else if (getAccount()) {
                await handleAuthenticated();
            }
        });
    }, [dispatch, handleAuthenticated]);

    // Fetch data when authenticated
       useEffect(() => {
         if (isAuthenticated && (canManageLicenses || canManageIntegrations) && !isAuthorized) {
           setIsAuthorized(true);
         }
         if (isAuthenticated && isAuthorized && retrieveIntegrationsStatus === Status.Idle) {
           dispatch(retrieveIntegrationsThunk());
         }
         if (
           isAuthenticated &&
           isAuthorized &&
           retrieveIntegrationsStatus === Status.Finished &&
           retrieveAllLicensesStatus === Status.Idle
         ) {
           dispatch(retrieveAllLicensesThunk({ integrationIds }));
         }
       }, [
         isAuthenticated,
         isAuthorized,
         canManageLicenses,
         canManageIntegrations,
         retrieveIntegrationsStatus,
         retrieveAllLicensesStatus,
         dispatch,
         integrationIds,
       ]);
    useEffect(() => {
        if (isAuthenticated && !isAuthorized) {
            setIsAuthorized(true);
        }
        if (isAuthenticated && isAuthorized && retrieveIntegrationsStatus === Status.Idle) {
            dispatch(retrieveIntegrationsThunk());
        }
        if (
            isAuthenticated &&
            isAuthorized &&
            retrieveIntegrationsStatus === Status.Finished &&
            retrieveAllLicensesStatus === Status.Idle
        ) {
            dispatch(retrieveAllLicensesThunk({ integrationIds }));
        }
    }, [
        isAuthenticated,
        isAuthorized,
        retrieveIntegrationsStatus,
        retrieveAllLicensesStatus,
        dispatch,
        integrationIds,
    ]);


    const isLoading = isAuthenticated && (!isAuthorized || retrieveIntegrationsStatus !== Status.Finished);

    return (
        <>
            <LoaderOverlay isLoading={isLoading} />
            <AppBar isAuthenticated={isAuthenticated} onLoginButtonClicked={handleLoginButtonClicked} />
            <div className="container-fluid my-10">
                <Routing isAuthenticated={isAuthenticated} onAuthorizedEvent={handleAuthenticated} />
            </div>
            <AppFooter />
        </>
    );
}

export default App;
